export default "__VITE_ASSET__CgwRDAMF__"